import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
} from '@mui/material';
import { AddressType } from '../../../../../services/RegistrationService/registrationSlice';
import { useAddressForm } from './hooks';
import { AddressFormFields, DialogActionButtons } from './components';

interface AddressDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (address: AddressType) => void;
  address?: AddressType | null;
  title: string;
}

const AddressDialog: React.FC<AddressDialogProps> = ({
  open,
  onClose,
  onSave,
  address,
  title,
}) => {
  const {
    formData,
    availableAddressTypes,
    isLoading,
    handleChange,
  } = useAddressForm(address, open);

  const handleSave = () => {
    onSave(formData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h6" fontWeight={600} color="#1e293b">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <AddressFormFields
            formData={formData}
            availableAddressTypes={availableAddressTypes}
            isLoading={isLoading}
            onFieldChange={handleChange}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 2 }}>
        <DialogActionButtons
          isEditMode={!!address}
          onCancel={onClose}
          onSave={handleSave}
        />
      </DialogActions>
    </Dialog>
  );
};

export default AddressDialog;
